import type { Look } from './types.ts';

/** Who you can be. Each has an animated sheet at /art/char-<slug>.png (tools/build-art.py). */
export const SURVIVORS = [
  { slug: 'ws_wasteland_scavenger', name: 'Scavenger' },
  { slug: 'ws_rust_mechanic', name: 'Rust Mechanic' },
  { slug: 'ws_gas_mask_medic', name: 'Gas-Mask Medic' },
  { slug: 'ws_dust_ranger', name: 'Dust Ranger' },
  { slug: 'ws_scrap_guardian', name: 'Scrap Guardian' },
  { slug: 'ws_dune_hunter', name: 'Dune Hunter' },
  { slug: 'ws_voltage_raider', name: 'Voltage Raider' },
  { slug: 'ws_radioactive_alchemist', name: 'Glow Alchemist' },
  { slug: 'ws_wasteland_nomad', name: 'Nomad' },
  { slug: 'ws_caravan_trader', name: 'Caravan Trader' },
  { slug: 'zombie_wasteland_zombie_hunter', name: 'Roach Hunter' },
] as const;

/** Characters made before the reskin have no survivor; their old look picks one, always the same. */
export function survivorOf(look: Look): number {
  if (typeof look.survivor === 'number' && look.survivor >= 0 && look.survivor < SURVIVORS.length) return look.survivor;
  return (look.skin * 31 + look.cloth * 7 + look.accent * 3 + look.head.length) % SURVIVORS.length;
}
